/**
 *  基于vue扩展功能(全局组件，原型方法|属性，自定义指令，过滤器)
 *  这里指引入公共的组件，其他组件在使用页面进行按需引入的形式导入，否则会引起首次加载慢的问题
 *  tags暂时注掉，没这个需求
 */
import pages from "@/components/common/pages";
import ImgUpload from "@/components/content/imgUpload/imgUpload.vue";
import Editor from "@/components/common/quill-editor/quill-editor.vue";
import MyMap from "@/components/map/map.vue";
import {LuckyGrid, LuckyWheel} from '@lucky-canvas/vue'

export default {
  install: Vue => {
    // Vue 使用vue的构造函数  当main.js使用use的使用传入进来
    Vue.component(pages.name, pages);
    Vue.component(ImgUpload.name, ImgUpload);
    Vue.component(Editor.name, Editor);
    Vue.component(MyMap.name, MyMap);
    Vue.component('LuckyWheel', LuckyWheel)
    Vue.component('LuckyGrid', LuckyGrid)
  }
};
